import "../styles/globals.css";
import type { AppProps } from "next/app";
import { useRouter } from "next/router";
import Navbar from "../components/Common/Navbar/Navbar";
import Footer from "../components/Common/Footer";
import Starfield from "../components/Common/Starfield";
import SmoothScroll from "../components/Common/SmoothScroll";
import ScrollProgress from "../components/Common/ScrollProgress";
import ErrorBoundary from "../components/Common/ErrorBoundary";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RootLayout from "./RootLayout";

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  // The homepage hero is full-bleed under the fixed nav; every other page
  // needs top clearance so its heading isn't hidden behind the nav.
  const isHome = router.pathname === "/";

  return (
    <RootLayout>
      {/* Global deep-space background system (sits behind all pages) */}
      <div className="bg-field" aria-hidden />
      <Starfield density={1.3} />
      <div className="bg-grid" aria-hidden />

      {/* Landing-page motion: momentum smooth-scroll + GSAP reveals, plus a
          Framer Motion scroll-progress bar. Scoped to home so app pages keep
          native scrolling. */}
      {isHome && <SmoothScroll />}
      {isHome && <ScrollProgress />}

      <Navbar />
      <div className={isHome ? undefined : "app-main"}>
        <ErrorBoundary resetKey={router.asPath}>
          <Component {...pageProps} />
        </ErrorBoundary>
      </div>
      <Footer />
      {/*
        React 19 no longer applies `defaultProps` to function components when
        rendered via the automatic JSX runtime. react-toastify v9's
        <ToastContainer> relies on defaultProps to supply `transition` (and the
        rest of its config); with it missing, the internal Toast component does
        `createElement(undefined)` → "Element type is invalid … got: undefined"
        whenever a toast is shown (e.g. on every successful list/stake tx).
        Passing the defaults explicitly restores correct behavior and fixes the
        crash. (transition={Bounce} is the one that prevents the crash.)
      */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </RootLayout>
  );
}

export default MyApp;
